// extracted by mini-css-extract-plugin
module.exports = {"review-report-ifame":"review-report-ifame-965f516c0e0b9933f9a28f92366222fc","review-iframe":"review-iframe-fec9a5a877ecd97755d5809dd9bebdb1"};